// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"24b427cd","194":"81de0619","205":"591f66f9","207":"52f7dc3c","453":"5a1632e7","586":"9ea7542f","622":"3be97c3d","685":"4c9d3836","770":"a4151084","778":"a221da98"}[chunkId] + ".chunk.js";
};